<template>
  <v-container fluid class="asset-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-asset`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Asset
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-image-multiple</v-icon>
            Items
          </v-tab>
          <v-tab-item
            :value="'tab-asset'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Asset</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetcode')"
                        v-bind:value="initvalue.assetcode"
                        placeholder="Asset Code"
                        persistent-hint
                        single-line hint="Enter the asset code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetname')"
                        v-bind:value="initvalue.assetname"
                        placeholder="Asset Name"
                        persistent-hint
                        single-line hint="Enter the asset name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=assettype
                        :value="initvalue.assettype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assettype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the asset type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'assetstatus')"
                          v-bind:label="initvalue.assetstatus"
                          v-model="initvalue.assetstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/asset/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editAsset()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Items</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="showImageDialog = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_items"
                        :items="assetitems"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deleteImageDialog" width="500">
                            <v-card>
                              <v-card-title> Delete this Image? </v-card-title>
                              <v-card-text>
                                {{ deleteimage.assetname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deleteImageDialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteAssetImage(deleteimage)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.assetname="{ item }">
                          <p class="two-line"><strong>{{ item.assetname }}</strong></p>
                          <p v-if="item.assetvalue!=''" class="two-line">{{ item.assetvalue  }}</p>
                        </template>
                        <template v-slot:item.asseturl="{ item }">
                            <img v-if="item.asseturl" v-bind:src="item.asseturl" alt="" width="80">
                        </template>                          
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editAssetImageSheet(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteAssetImageDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/asset/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="showListDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add List</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="list.listrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="list.listtext"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="list.listvalue"
                  label="Value"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="list.textinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showListDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addAssetList"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showImageDialog"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Image</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="image.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="image.assetname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input outlined dense label="File input" v-on:change="onImageFileChange" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  outlined
                  dense
                  v-model="image.assetinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="showImageDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addAssetImage"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
      <v-bottom-sheet scrollable v-model="showListSheet" inset>
        <v-sheet class="text-center" height="250px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showListSheet = !showListSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listrank')"
                  :value="editlist.listrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listtext')"
                  v-model="editlist.listtext"
                  label="Text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="updateChangedList($event, 'listvalue')"
                  v-model="editlist.listvalue"
                  label="Value"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="updateChangedList($event, 'textinfo')"
                  v-model="editlist.textinfo"
                  label="Info"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editAssetList()"
          >
            Edit
          </v-btn>
              </v-col>
          </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
      <v-bottom-sheet scrollable v-model="showImageSheet" inset>
        <v-sheet class="text-center" height="350px" style="overflow-x: hidden;">
          <v-btn class="mt-6" text color="error" @click="showImageSheet = !showImageSheet">
            close
          </v-btn>
          <v-row justify="center">
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'imagerank')"
                  :value="editimage.imagerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-on:change="updateChangedImage($event, 'assetname')"
                  :value="editimage.assetname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="5">
              <v-file-input outlined dense label="File input" v-model="imagefile" v-on:change="onImageFileChange" accept="image/*" />     
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                outlined
                dense
                v-on:change="updateChangedImage($event, 'assetinfo')"
                :value="editimage.assetinfo"
                label="Info"
                required
              ></v-text-field>
            </v-col>
          </v-row>
           <v-row justify="center">
              <v-col cols="12" md="11">
                 <v-btn
            class="button-shadow"
            color="warning"
            @click="editAssetImage()"
          >
            Edit
          </v-btn>
              </v-col>
           </v-row>
         
        </v-sheet>
      </v-bottom-sheet>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_items: [
        { text: "#", value: "assetrank", width: "3%" },
        { text: "Image", value: "asseturl", width: "8%"},
        { text: "Name", value: "assetname" , width: "65%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      asset: {},
      assetitems: [],
      assetimages: [],
      initvalue: {},
      assettype: ['Image', 'List', 'Video'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      list: {},
      editlist: {},
      deletelist: {},
      deleteListDialog: false,
      showListDialog: false,
      showListSheet: false,
      image: {},
      imagefile: null,
      editimage: {},
      deleteimage: {},
      deleteImageDialog: false,
      showImageDialog: false,
      showImageSheet: false,
    }
  },
  methods: {
    ...mapActions('Asset', [
      'getAssetsRequest',
      'deleteAssetImageRequest', 'deleteAssetListRequest',
      'insertAssetListRequest', 'insertAssetImageRequest',
      'updateAssetRequest','updateAssetImageRequest','updateAssetListRequest',
    ]),
    async addAssetList() {
      this.showListDialog = false;
      this.list.assetid = this.initvalue._id;
      let result = await this.insertAssetListRequest(this.list);
      this.assetitems.push(result);
      this.list = {};
    },
    async addAssetImage() {
      this.showImageDialog = false;
      this.image.assetid = this.initvalue._id;
      let result = await this.insertAssetImageRequest(this.image);
      this.assetimages.push(result);
      this.image = {};
    },
    deleteAssetListDialog(item) {
      this.deleteListDialog = true;
      this.deletelist = {
        _id: item._id,
        listtext: item.listtext,
      };
    },
    deleteAssetImageDialog(item) {
      this.deleteImageDialog = true;
      this.deleteimage = {
        _id: item._id,
        assetname: item.assetname,
      };
    },
    async deleteAssetList(payload) {
      this.deleteListDialog = false;
      let response = await this.deleteAssetListRequest(payload);
      let index = this.assetitems.findIndex((trans) => trans._id == response._id);
      this.assetitems.splice(index, 1);
    },
    async deleteAssetImage(payload) {
      this.deleteImageDialog = false;
      let response = await this.deleteAssetImageRequest(payload);
      let index = this.assetimages.findIndex((trans) => trans._id == response._id);
      this.assetimages.splice(index, 1);
    },
    editAsset() {
      this.asset._id = this.initvalue._id;
      this.updateAssetRequest(this.asset);
      this.getAssetsRequest();
      router.push('/asset/list');
    },
    async editAssetList() {
      this.showListSheet = false;
      this.list.assetlistid = this.editlist._id;
      let response = await this.updateAssetListRequest(this.list);
      let index = this.assetitems.findIndex((x) => x._id == response._id);
      this.assetitems.splice(index, 1, response);
    },
    editassetitemsheet(item) {
      this.list = {};
      this.showListSheet = true;
      this.editlist = Object.assign({}, item);
    },
    editAssetImageSheet(item) {
      this.image = {};
      this.showImageSheet = true;
      this.editimage = Object.assign({}, item);
    },
    async editAssetImage() {
      this.showImageSheet = false;
      this.imagefile = null;
      this.image.assetimageid = this.editimage._id;
      let response = await this.updateAssetImageRequest(this.image);
      let index = this.assetimages.findIndex((x) => x._id == response._id);
      this.assetimages.splice(index, 1, response);
    },
    onImageFileChange(file) {
      if (!file) {return;}
      this.image.imagefile = file;
      this.image.imagefilename = file.name;
    },
    updateChangedValue(value, field){
      this.asset[field] = value;
    },
    updateChangedImage(value, field){
      this.image[field] = value;
    }, 
    updateChangedList(value, field){
      this.list[field] = value;
    },    
  },
  computed: {
    ...mapState('Asset', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    this.assetitems = this.initvalue.assetitems;
    this.assetimages = this.initvalue.assetimages;
    if(!this.initvalue._id) this.$router.push({ name: 'AssetList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
